import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/common/Icon';
import Dropdown from 'components/common/Dropdown';
import NotificationBell from 'components/common/NotificationBell';
import ManualUploadNotification from 'components/common/ManualUploadNotification';
import { selectCurrentUser } from 'features/auth/authSelectors';
import { logout } from 'features/auth/authThunks';
import { ROUTES } from 'constants/routes';
import './Header.css';

/** Top app bar: sidebar toggles + user menu. */
const Header = ({ onToggleSidebar, onToggleMobileSidebar }) => {
  const user = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await dispatch(logout());
    navigate(ROUTES.LOGIN, { replace: true });
  };

  const initials = (user?.fullName || '?')
    .split(' ')
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <header className="kvo-header">
      <div className="kvo-header__left">
        <button
          type="button"
          className="kvo-header__icon-btn kvo-header__icon-btn--desktop"
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <Icon name="menu" size={20} />
        </button>
        <button
          type="button"
          className="kvo-header__icon-btn kvo-header__icon-btn--mobile"
          onClick={onToggleMobileSidebar}
          aria-label="Open menu"
        >
          <Icon name="menu" size={20} />
        </button>
      </div>

      <div className="kvo-header__right" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <ManualUploadNotification />
        <NotificationBell />
        <Dropdown
          align="right"
          trigger={
            <button type="button" className="kvo-header__user">
              <span className="kvo-header__avatar">{initials}</span>
              <span className="kvo-header__user-meta">
                <span className="kvo-header__user-name">{user?.fullName}</span>
                <span className="kvo-header__user-role">{user?.roleName}</span>
              </span>
              <Icon name="chevronDown" size={14} />
            </button>
          }
          items={[
            { id: 'role', label: user?.roleName || 'Account', icon: 'user', disabled: true },
            { id: 'phone', label: user?.phoneNumber || '', icon: 'user', disabled: true },
            { divider: true },
            { id: 'logout', label: 'Sign out', icon: 'logout', danger: true, onClick: handleLogout },
          ]}
        />
      </div>
    </header>
  );
};

export default Header;
